<template>
    <div v-if="client">
        <!-- is test environment -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Test environment</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="client.settings.tvbetSettings.testEnvironment"
                                   type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- tvbet client id -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">TVBet client ID</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.tvbetSettings.tvbetClientId"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- server -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Server</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.tvbetSettings.server"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- private key -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Private key</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.tvbetSettings.privateKey"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- start page -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Start Page</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="client.settings.tvbetSettings.startPage"
                               class="input"
                               type="text" />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../state';
import utils from '../../../../utils';
import clientService from '../../../../services/client.service';

export default {
    name: 'client-settings-tvbet',
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        currencies() {
            return state.currencies.get();
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/tvbet.vue